import React from "react"
import { Grid, Typography, Link, Box } from "@material-ui/core"

import useStyles from "@/components/InfoCard/styles"

type InfoCardProps = {
	icon: React.ReactNode
	title: string
	description: React.ReactNode
	ctaHref: string
	ctaLabel: string
}

const InfoCard: React.FC<InfoCardProps> = ({ icon, title, description, ctaHref, ctaLabel }) => {
	const classes = useStyles()

	return (
		<Grid container alignItems="flex-start" spacing={2} wrap="nowrap" className={classes.card}>
			<Grid item>
				<Box className={classes.iconBox}>
					{icon}
				</Box>
			</Grid>
			<Grid item xs>
				<Typography variant="body2" className={classes.title}>
					{title}
				</Typography>
				<Typography variant="body2" className={classes.description}>
					{description}
				</Typography>
				<Link
					href={ctaHref}
					target="_blank"
					underline="none"
					className={classes.cta}
				>
					{ctaLabel}
				</Link>
			</Grid>
		</Grid>
	)
}

export default InfoCard
